<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-25 09:38:43
 * @LastEditors: xgx
 * @LastEditTime: 2023-08-02 11:11:18
-->
<template>
  <div class="box">
    <div class="search">
      <div class="left">
        <el-button
          @click="toAddManuscript"
           v-if="codeData.indexOf('348') != -1"
          type="primary"
          >增加报送</el-button
        >
      </div>
      <div class="right">
         <a-range-picker style="margin-right:12px;width:300px" showTime v-model="time" format="YYYY-MM-DD HH:mm:ss"/>
        <el-select
            clearable
            style="margin-left: 10px;width:160px"
            v-model="dataType"
            placeholder="按报送方式筛选"
          >
           
            <el-option label="栏目推送" :value="1"> </el-option>
            <el-option label="约稿" :value="2"> </el-option>
            <el-option label="新增报送" :value="3"> </el-option>
        </el-select>
        <el-select
            clearable
            style="margin-left: 10px;width:160px"
            v-model="adoptState"
            placeholder="按采纳状态筛选"
          >
           
            <el-option label="待采纳" :value="1"> </el-option>
            <el-option label="已采纳" :value="2"> </el-option>
            <el-option label="未采纳" :value="3"> </el-option>
        </el-select>
       <a-input-group compact>
                <a-select
                v-model="selectName"
                style="width: 100px; background: #ccc;margin-left:12px"
                >
                <a-select-option
                    @click="selectFn(item.value)"
                    :key="index"
                    v-for="(item, index) in selectArr"
                >
                    {{ item.label }}
                </a-select-option>
                </a-select>
                <a-input
                v-model="seachValue"
                placeholder="请输入搜索内容"
                style="width: 130px;margin-right:12px"
                />
            </a-input-group>
        <el-button  @click="listSearch" type="primary" 
          >查询</el-button 
        >
      </div>
    </div>
    <coententTable
      :y="height"
      @onShowSizeChange="onShowSizeChange"
      :columns="columns"
      :dataSource="dataSource"
      :pagination="pagination"
      :customSlot="customSlot"
      @handleSizeChange="handleSizeChange"
      :loading="loading"
    >
     <template v-slot:adoptState="scopeVal">
         {{scopeVal.scope.adoptState == 1?"待采纳":scopeVal.scope.adoptState == 2?"已采纳":"未采纳"}}
      </template>
      <template v-slot:type="scopeVal">
         {{scopeVal.scope.type == 1?"栏目推送":scopeVal.scope.type == 2?"约稿":"新增报送"}}
      </template>
       <template v-slot:number="scopeVal">
         <span v-if="scopeVal.scope.number">+</span>{{scopeVal.scope.number?scopeVal.scope.number:'—'}}
      </template>
      <template v-slot:stateRizhi="scopeVal">
         <a style="color:rgba(24, 109, 230, 1);" v-if="codeData.indexOf('355') != -1" @click="see(scopeVal.scope)"
            >查看</a
          >
      </template>
     <template v-slot:titleName="scopeVal">
        <div v-if="scopeVal.scope.type == 1" @click="toPath(scopeVal.scope)" class="title-box">{{scopeVal.scope.title}}</div>
        <div style="cursor: pointer;" @click="chaKan(scopeVal.scope)" v-else>{{scopeVal.scope.title}}</div>
     </template>
    </coententTable>
    <See :item="itemData" @closeTwo="closeTwo" :visible="visible"></See>
     <AddSubmission :isAdd="isAdd" :item="itemData" :type="2" @onClose="onClose" @close="close" :visible="visibleAdd"></AddSubmission>
    <Tips :item="itemData"  @onClose="onCloseTips" @close="onCloseTips" :visible="visibleAddTips"/>
  </div>
</template>

<script>
import {
  selectListPage,
} from "./index";
import coententTable from "@/components/coentent_table.vue";
import See from "@/components/more_information.vue";
import AddSubmission from './add_submission.vue';
import Tips from './tips.vue';
export default {
  data() {
    return {
      selectName: "标题",
      visible:false,
      selectValue: 1,
      seachValue:'',
      visibleAddTips:false,
      selectArr:[
                {
                    'label':'标题',
                    'value':1,
                },
                {
                    'label':'创作人员',
                    'value':2,
                }
            ],
      height: 0,
      time: [],
      columns: [
        {
          title: "标题",
          dataIndex: "title",
          ellipsis: true,
          customCell: column => {
            return {
              style: {
                'min-width': "320px",
                'max-width': "500px",
              }
          };
        },
        customHeaderCell: column => {
          return {
             style: {
                'min-width': "320px",
                'max-width': "500px",
              }
          };
        },
        scopedSlots: { customRender: "titleName" },
      },
        {
          title: "报送方式",
          dataIndex: "type",
          width: 120,
          ellipsis: true,
          scopedSlots: { customRender: "type" },
        },
        {
          title: "采纳状态",
          dataIndex: "adoptState",
          width: 120,
          scopedSlots: { customRender: "adoptState" },
        },
         {
          title: "采纳时间",
          dataIndex: "adoptTime",
          width: 200,
        },
         {
          title: "加分组织",
          dataIndex: "organName",
          width: 200,
        },
         {
          title: "加分值",
          dataIndex: "number",
           scopedSlots: { customRender: "number" },
          width: 200,
        },
        {
          title: "日志",
          dataIndex: "stateRizhi",
          scopedSlots: { customRender: "stateRizhi" },
          width: 120,
        },
      ],
      pagination: {
        current: 1,
        pageSize: 15,
        total: 0,
        pageSizeOptions: ["15", "25", "35"],
      },
      dataSource: [],
      customSlot: [
        {
          name: "stateRizhi",
          customRender: "stateRizhi",
        },
         {
          name: "adoptState",
          customRender: "adoptState",
        },
         {
          name: "type",
          customRender: "type",
        },
        {
          name: "titleName",
          customRender: "titleName",
        },
         {
          name: "number",
          customRender: "number",
        },
      ],
      loading: false,
      codeData: [],
      dataType:'',
      adoptState:'',
      itemData:{},
      isAdd:false,
      visibleAdd:false,
    };
  },
  components: {
    coententTable,
    See,
    AddSubmission,
    Tips,
  },
  mounted() {
    this.getList();
    this.codeData = JSON.parse(sessionStorage.getItem("menuData"));
  },
  methods: {
    closeTwo(){
      this.visible = false;
    },
     close(){
       this.visibleAdd = false;
    },
    chaKan(item){
      this.itemData = item;
      this.visibleAddTips = true;
    },
     onClose(){
      this.visibleAdd = false;
      this.getList()
    },
    onCloseTips(){
       this.visibleAddTips = false;
    },
     farmatDate(date, cut) {
      var date = new Date(date);
      var YY = date.getFullYear() + cut;
      var MM =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + cut;
      var DD = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      var hh =
        (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
      var mm =
        (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
      (":");
      var ss =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      return YY + MM + DD + " " + hh + mm + ss;
    },
     toAddManuscript() {
       this.visibleAdd = true;
        this.isAdd = true;
        this.itemData = {};
    },
    see(item) {
       this.visible = true;
       this.itemData = item;
    },
    selectFn(value) {
      this.selectValue = value;
    },
    listSearch() {
      this.pagination.current = 1;
      this.getList();
    },
    getList() {
      this.loading = true;
      let startTime = '';
      let endTime = '';
      if(this.time.length > 0){
        startTime  = this.farmatDate(new Date(this.time[0].toString()).getTime(),'-')
        endTime = this.farmatDate(new Date(this.time[1].toString()).getTime(),'-')
      }
      selectListPage({
        current: this.pagination.current,
        size: this.pagination.pageSize,
        value: this.seachValue,
        type: this.selectValue,
        dataType:this.dataType,
        adoptState:this.adoptState,
        startTime,
        endTime,
        organizationId: JSON.parse(sessionStorage.getItem("userInfo")).organizationId,
      }).then((res) => {
        this.dataSource = res.data.records;
        this.pagination.current = res.data.current;
        this.pagination.total = res.data.total;
        if(this.pagination.total > 0){
          this.height = document.documentElement.clientHeight - 400;
          window.onresize = () => {
            return (() => {
              this.height = document.documentElement.clientHeight - 400;
            })();
          };
        }
        if (this.pagination.current != 1 && this.dataSource.length == 0) {
          this.pagination.current--;
          this.getList();
        }
        this.loading = false;
      });
    },
    onShowSizeChange(current) {
      this.pagination.current = current;
      this.getList();
    },
    handleSizeChange(pageSize) {
      this.pagination.current = 1;
      this.pagination.pageSize = pageSize;
      this.getList();
    },
     toPath(item){
        window.open(item.viewUrl)
    },
  },
};
</script>

<style lang="less" scoped>
.box {
  width: 100%;
  .search {
    padding: 24px;
    display: flex;
    width: 100%;
    padding-bottom: 0px;
    justify-content: space-between;
    .left {
      display: flex;
      align-items: center;
    }
    .icon-st-doc-edit:before {
      color: #fff;
      margin-right: 5px;
      font-size: 16px;
    }
    .batch-operation {
      margin-left: 10px;
      margin-right: 12px;
      /deep/ .ant-btn,
      .ant-dropdown-trigger {
        height: 40px;
        background: #ecf5ff;
        color: #18abff;
        border-color: #c9e3ff;
        text-align: center;
      }
    }
    .right {
      display: flex;
      /deep/ .ant-select-selection {
        background-color: rgba(245, 247, 250, 1);
        height: 40px;
      }
      /deep/ .ant-input {
        background-color: rgba(245, 247, 250, 1);
        height: 40px;
      }
      /deep/ .el-select .el-input__inner {
        background-color: rgba(245, 247, 250, 1);
      }
      /deep/ input::-webkit-input-placeholder {
        color: rgba(102, 111, 128, 1);
      }
      /deep/ .ant-select-selection__placeholder {
        color: rgba(102, 111, 128, 1);
      }
      /deep/ .ant-select-selection__rendered {
        line-height: 39px;
      }
      /deep/ .el-select__tags {
        white-space: nowrap;
        overflow: hidden;
      }
      /deep/ .el-select__tags {
        flex-wrap: nowrap;
      }
    }
  }
}
.open-style {
  border-bottom: solid 1px #ccc;
  padding-bottom: 12px;
  padding-top: 12px;
  max-width: 200px;
}
.content {
  max-height: 400px;
  overflow-y: auto;
}
.colum-title-box {
  height: 34px;
  line-height: 34px;
  border-radius: 4px;
  background-color: rgba(244, 244, 245, 1);
  padding-left: 12px;
  color: rgba(144, 147, 153, 1);
}
.column-box {
  /deep/ .ant-table-body {
    max-height: 450px;
    overflow: auto;
  }
  /deep/ .el-dialog__body {
    padding-bottom: 10px;
  }
}
.column-style {
  display: flex;
  cursor: pointer;
}
.item-one {
  color: rgba(96, 98, 102, 1);
  font-size: 14px;
  text-align: left;
  font-family: HarmonyOS_Sans_SC-regular;
  margin-bottom: 5px;
  line-height: 20px;
}
.column-number {
  padding: 0 10px;
  height: 20px;
  border-radius: 3px;
  background-color: rgba(236, 245, 255, 1);
  color: rgba(64, 158, 255, 1);
  font-size: 12px;
  text-align: center;
  font-family: Roboto;
  border: 1px solid rgba(217, 236, 255, 1);
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 56px;
}
.column-numberTwo {
  width: 56px;
  height: 20px;
  line-height: 16px;
  border-radius: 3px;
  background-color: rgba(244, 244, 245, 1);
  color: rgba(144, 147, 153, 1);
  font-size: 12px;
  text-align: center;
  font-family: Roboto;
  border: 1px solid rgba(211, 212, 214, 1);
}
/deep/ .el-dialog__title {
  font-weight: 600;
}
/deep/ .el-dialog__close {
  font-weight: 600;
  color: #000;
}
.footer-style {
  text-align: right;
  margin-right: 23px;
  margin-bottom: 12px;
}
.column-box-two, .column-box {
  /deep/ .table {
    margin-bottom: 24px;
    margin-left: 0;
    margin-right: 0;
  }
  /deep/
    .ant-table-tbody
    > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)
    > td {
    background: #fafafa;
  }
}
.title-top {
  display: flex;
  justify-content: space-between;
  margin-bottom: 14px;
  margin-top: 10px;
  .title-top-left {
    height: 17px;
    color: rgba(48, 49, 51, 1);
    font-size: 14px;
    text-align: left;
    font-family: HarmonyOS_Sans_SC-regular;
  }
  .title-top-right {
    color: rgba(144, 147, 153, 1);
    font-size: 14px;
    text-align: right;
    font-family: HarmonyOS_Sans_SC-regular;
  }
}
.btnTwo {
  border-radius: 3px;
  background-color: rgba(240, 246, 255, 1);
  color: rgba(23, 109, 230, 1);
  font-size: 12px;
  font-family: Roboto;
  border: 1px solid rgba(23, 109, 230, 1);
  width: 56px;
  height: 28px;
  line-height: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.btnThree {
  width: 56px;
  height: 28px;
  line-height: 16px;
  border-radius: 3px;
  background-color: rgba(255, 242, 242, 1);
  color: rgba(245, 108, 108, 1);
  font-size: 12px;
  text-align: center;
  font-family: Roboto;
  border: 1px solid rgba(245, 108, 108, 1);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.btnFour {
  width: 56px;
  height: 28px;
  line-height: 16px;
  border-radius: 3px;
  background-color: rgba(244, 244, 245, 1);
  color: rgba(144, 147, 153, 1);
  font-size: 12px;
  text-align: center;
  font-family: Roboto;
  border: 1px solid rgba(211, 212, 214, 1);
  display: flex;
  justify-content: center;
  align-items: center;
}
.el-button--primary {
  background: #176de6;
}
/deep/ .ant-dropdown-trigger {
  border-radius: 3px;
  background-color: rgba(240, 246, 255, 1) !important;
  text-align: center;
  border: 1px solid rgba(23, 109, 230, 1) !important;
  color: rgba(23, 109, 230, 1) !important;
  font-size: 14px;
  text-align: left;
  font-family: HarmonyOS_Sans_SC-regular;
}
  /deep/ .ant-input-group{
    width: auto;
  }
  .title-box {
  overflow: hidden; 
  text-overflow: ellipsis;
  white-space: nowrap;
  text-decoration:underline;
  color: rgba(24, 109, 230, 1);
  cursor: pointer;
  }
</style>